<template>
  <el-dialog :title="$t('message.Exporting')" :visible.sync="dialogProgressVisible"
    :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
    width="350px">
    <el-progress type="circle" :percentage="percentage" :color="colors"></el-progress>
  </el-dialog>
</template>

<script>
  import html2Canvas from 'html2canvas'
  import jsPDF from 'jspdf'
  import _global from './global.vue';
  import 'jspdf-autotable'
  import (/* webpackChunkName: "STXIHEI-normal"*/ '../assets/fonts/STXIHEI-normal.js')
  import (/* webpackChunkName: "STCUHEI-normal"*/ '../assets/fonts/STCUHEI-normal.js')

  export default {
    name: 'export_pdf',
    props: {
    },
    data() {
      return {
        dialogProgressVisible: false,
        percentage: 0,
        colors: [
          {color: '#FE4E11', percentage: 20},
          {color: '#FF8E15', percentage: 40},
          {color: '#FAB733', percentage: 60},
          {color: '#ACB334', percentage: 80},
          {color: '#69B34C', percentage: 100}
        ]
      }
    },
    methods: {
      showDialog(){
        this.dialogProgressVisible = true
      },
      async getPdf (param) {
        // Create new PDF file

        this.percentage = 10

        let PDF = new jsPDF('', 'pt', 'a4')
        let title = 'JCDecaux Bus Media Solution_' 
        PDF.addFont('STXIHEI-normal.ttf', 'STXIHEI', 'normal');
        PDF.addFont('STCUHEI-normal.ttf', 'STCUHEI', 'normal');
        PDF.setFont('STXIHEI');

        var picSrc = ''
        if (_global.serverSrc == 'http://127.0.0.1:8000/api'){
          //picSrc = '/frontend/img/'
          picSrc = '/static/img/'
        }
        else{
          picSrc = '/img/'
        }
        
        
        // Add cover page
        let leftMargin = 65.205/2
        let rightMargin = leftMargin
        let a4Width = 595.28
        let a4Height = 841.89

        let BusLogo = new Image()
        let BusLogoUrl = _global.serverSrc.slice(0,-4) + picSrc+ 'logo_cn.png';
        //JcdLogo.src = require('../assets/jcd_logo.png')
        BusLogo.src = BusLogoUrl
        PDF.addImage(BusLogo,'png',a4Width/2-50.5,30,101,49)

        let BamLogo = new Image()
        let BamLogoUrl = _global.serverSrc.slice(0,-4) + picSrc + 'bam_logo.png';
        //JcdLogo.src = require('../assets/jcd_logo.png')
        BamLogo.src = BamLogoUrl
        PDF.addImage(BamLogo,'png',a4Width/2-134.75,a4Height/2-87.5,269.5,115)

        if (param.clientLogoImage !=''){
          let img = new Image()
          img.src = param.clientLogoImage
          await img.decode();
          let width = Number(img.width)/Number(img.height) * 100
          PDF.addImage(param.clientLogoImage,'png',a4Width/2 - width/2,a4Height/2+87,width,100)
        }
        //throw new Error("ERROR")
        PDF.setFontSize(20);
        PDF.text(param.clientName,a4Width/2,680.4,'center')

        //Add Date
        let reportDate = new Date()
        let monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let reportDate_output = monthsList[reportDate.getMonth()].toString()+ ' ' +reportDate.getDate().toString()+' '+reportDate.getFullYear().toString()
        let reportDate_output_YYMMDD = reportDate.getFullYear()+'/'+(Number(reportDate.getMonth())+1).toString()+'/'+reportDate.getDate()

        PDF.setFontSize(14);
        PDF.setFontType("normal");
        PDF.text(reportDate_output_YYMMDD,a4Width/2,a4Height-30,'center')
        
        let campaignStartDate = new Date(param.campaignDateTimestamp);
        let campaignStartDate_YYMMDD = campaignStartDate.getFullYear()+'/'+(Number(campaignStartDate.getMonth())+1).toString()+'/'+campaignStartDate.getDate()

        this.percentage = 20

        //Report Info Page
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)

        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')
        PDF.setFontSize(14);
        PDF.setFont('Helvetica')
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        
        let discountType = ""
        if (param.pricingMode == 'media') {
          discountType = '单媒体 / Media'
        }
        else {
          discountType = '总提案 / Proposal'
        }

        let infoTableY = 129.575
        let infoTable = [
          [{content: '发布城市 / City: '+ param.chosen_city, styles: {fontSize: 12, font: 'STCUHEI', textColor: [41,128,186]}}, ''],
          [{content: '方案名称 / Name: ' + param.clientName, styles: {font: 'STCUHEI'}}, {content: '方案编号# / Proposal#: '+ param.reference_id, styles: {font: 'STXIHEI'}}],
          [{content: 'BU销售人员 / BU Sales: ' + param.team +' / '+ param.createdBy, styles: {font: 'STXIHEI'}}, {content: '报告时间 / Report Date: '+reportDate_output_YYMMDD, styles: {font: 'STXIHEI'}}],

          [{content: '计划发布日期 / Campaign Start: '+ campaignStartDate_YYMMDD, styles: {font: 'STXIHEI'}}, {content: '发布时长（月）/ Duration(month): '+ param.campaignDuration, styles: {font: 'STXIHEI'}}],
          [{content: '巴士线路数量 / No. of bus lines: '+ param.tableData[0].value, styles: {font: 'STXIHEI'}}, {content: "巴士台数 / Bus Q'ty: "+ param.tableData[1].value, styles: {font: 'STXIHEI'}}],
          
          [{content: '提案总价 / Total Cost ￥: ' + param.proposalDiscountCost.toLocaleString(), styles: {fontSize: 12, font: 'STCUHEI', textColor: [41,128,186]}}, {content: '提案刊例价 / Initial Rate Card ￥: '+ param.proposalCost, styles: {font: 'STXIHEI'}}],
        ]
        //{content: '折扣类型 / Discount Type: '+ discountType, styles: {font: 'STXIHEI'}}
        //{content: '实付比率 / Reduced Rate: '+ param.proposalDiscount + ' %', styles: {font: 'STXIHEI'}}

        PDF.autoTable({
          body: infoTable,
            //styles: { font: "helvetica", fontStyle: 'bold'} ,
            tableWidth: 'auto',
            startY: infoTableY,
        })

        PDF.setDrawColor(134,164,218); // draw blue lines
        PDF.setLineWidth(0.1);
        PDF.rect(41, infoTableY + 67.425, 516, 43); // rect line

        //Imp CPM table
        let impCpmRectY = 273
        PDF.setFillColor(41,128,186); // draw blue rect
        PDF.rect(leftMargin+7, impCpmRectY, a4Width/2 - 50, 70, 'F');
        PDF.rect(a4Width/2+10, impCpmRectY, a4Width/2 - 50, 70, 'F');
        
        PDF.setFont('STCUHEI');
        PDF.setTextColor(255,255,255)

        if (param.ifShowViewed) {
          PDF.setFontSize(12);
          PDF.text('广告有效展示次数\nViewed Impressions', leftMargin+7+6, impCpmRectY+18)
          PDF.setFontSize(14);
          PDF.text(param.tableData[4].value, leftMargin+150+45, impCpmRectY+23, 'center')
          
          PDF.setFontSize(10);
          PDF.text('基于目标受众 / Cluster', leftMargin+7+6, impCpmRectY+18+24+12)
          PDF.text(param.tableData[5].value, leftMargin+150+45, impCpmRectY+18+24+12, 'center')
        }
        else {
          PDF.setFontSize(12);
          PDF.text('广告有效展示次数\nViewed Impressions', leftMargin+7+6, impCpmRectY+35-3)
          PDF.setFontSize(14);
          PDF.text(param.tableData[4].value, leftMargin+150+45, impCpmRectY+35+3, 'center')
        }
        
        PDF.setFontSize(12);
        PDF.text('提案 CPM\nProposal CPM ￥', a4Width/2+10+6, impCpmRectY+18)
        PDF.setFontSize(14);
        PDF.text(param.discountProposalCPM, a4Width/2+10+150+45, impCpmRectY+23, 'center')
        
        PDF.setFontSize(10);
        PDF.text('提案刊例价 CPM\nProposal Rate Card CPM ￥', a4Width/2+10+6, impCpmRectY+18+24+9)
        PDF.text(param.proposalCPM, a4Width/2+10+150+45, impCpmRectY+18+24+12, 'center')

        
        PDF.setTextColor(0,0,0)
        let ifShowViewedDescendPixel = 0

        //Selected criterias table
        let criteriasTableY = 375
        PDF.setFont('STXIHEI');
        PDF.setFontSize(10);
        PDF.text('受众特征 Audience Criterias: ', leftMargin+7, criteriasTableY)
        let bodyContent = []
        if (param.poi.length == 0 && param.poi_ba_label_selection_list == 0) {
          bodyContent = [
            ['性别 / Gender: '+ param.gender,'年龄 / Age: '+ param.age],
            ['消费能力 / Spend Power: '+ param.spend_power,"兴趣 / Interest: "+ param.interest],
          ]
        }
        else if (param.poi.length == 0) {
          bodyContent = [
            ['性别 / Gender: '+ param.gender,'年龄 / Age: '+ param.age],
            ['消费能力 / Spend Power: '+ param.spend_power,"兴趣 / Interest: "+ param.interest],
            ["途径地点 / Nearby Location: "+ param.poi_ba_label_selection_list, ""],
            ['经过途经地点线路总数/Pass nearby location bus number: '+ param.totalNearbyBusNumber.toString()]
          ]
        }
        else if (param.poi_ba_label_selection_list == 0) {
          bodyContent = [
            ['性别 / Gender: '+ param.gender,'年龄 / Age: '+ param.age],
            ['消费能力 / Spend Power: '+ param.spend_power,"兴趣 / Interest: "+ param.interest],
            ['目标兴趣点 / Target POI: '+ param.poi, ""],
          ]
        }
        else {
          bodyContent = [
            ['性别 / Gender: '+ param.gender,'年龄 / Age: '+ param.age],
            ['消费能力 / Spend Power: '+ param.spend_power,"兴趣 / Interest: "+ param.interest],
            ['目标兴趣点 / Target POI: '+ param.poi,"途径地点 / Nearby Location: "+ param.poi_ba_label_selection_list],
            ['经过途经地点线路总数/Pass nearby location bus number: '+ param.totalNearbyBusNumber.toString()]
          ]
        }

        PDF.autoTable({
          body: bodyContent,
          styles: { font: "STXIHEI",fontSize:8,} ,
          tableWidth:  'auto',
          startY: criteriasTableY + 11.735,
          columnStyles: {
            1: {cellWidth:267}
          }  
        })

        let poi_ba_character_length = param.poi_ba_label_selection_list.length

        this.percentage = 30
        
        //chart imp & CPM
        await html2Canvas(document.querySelector('#chart_impression'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)
          let startLocationChartImpression = 460
          let contentWidthChartImpression = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartImpression = 141.75+35+15

          // Incase to poi list too long
          if (poi_ba_character_length>40){
            startLocationChartImpression = startLocationChartImpression + 20
            contentWidthChartImpression = contentWidthChartImpression * 3/4
            contentHeightChartImpression = contentHeightChartImpression * 3/4
          }

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartImpression,  contentWidthChartImpression, contentHeightChartImpression)

        })

        await html2Canvas(document.querySelector('#chart_cpm'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)
          let startLocationChartCpm = 460
          let contentWidthChartCpm = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartCpm = 141.75+35+15

          // Incase to poi list too long
          if (poi_ba_character_length>40){
            startLocationChartCpm = startLocationChartCpm + 10
            contentWidthChartCpm = contentWidthChartCpm * 3/4
            contentHeightChartCpm = contentHeightChartCpm * 3/4
          }

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartCpm,  contentWidthChartCpm, contentHeightChartCpm)

        })

        this.percentage = 40

        //chart index & grade
        await html2Canvas(document.querySelector('#chart_index'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)
          let startLocationChartIndex = 670
          let contentWidthChartIndex  = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartIndex  = 60

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChartIndex,  contentWidthChartIndex , contentHeightChartIndex )

        })

        await html2Canvas(document.querySelector('#chart_rank'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,

        }).then(function(canvas){
          PDF.setPage(2)
          let startLocationChartRank = 670
          let contentWidthChartRank = (a4Width - leftMargin - rightMargin)/2
          let contentHeightChartRank = 60

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChartRank,  contentWidthChartRank, contentHeightChartRank)

        })

        PDF.setFont('STXIHEI');
        PDF.setFontSize(6);
        PDF.text('Index: 动态推荐指数，根据您的选择对最佳巴士线路进行推荐。机制：平均值 = 100。', leftMargin+7, 743)
        PDF.text('注意：多个条件会同时影响指数数值：受众的特征，以及与POI的组合。', leftMargin+7, 752)
        PDF.text('Index : The best performing Line according to criterias selected. General mechanism : Average = 100.', leftMargin+7, 770)
        PDF.text('Note : Multiple criterias are affecting the index value : the characteristics of the audience, but also the combination with POIs.', leftMargin+7, 779)

        this.percentage = 50

        //Page 2
        //Bus Line Detail Page
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
        PDF.setFont('Helvetica')
        PDF.setFontSize(14);
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')
        
        let titleTable = [
          [{content: '发布城市 / City: '+ param.chosen_city, styles: {fontSize: 12, font: 'STCUHEI', textColor: [41,128,186]}}, {content: '方案名称 / Name: ' + param.clientName, styles: {font: 'STCUHEI'}}],
      ]
        PDF.autoTable({
          body: titleTable,
            styles: { font: "STXIHEI"} ,
            //theme:'grid',
            tableWidth: 'auto',
            //cellWidth:250,
            //fontSize:14,
            startY: 123.575+6,
            lineWidth: 10,
            columnStyles: {
              1: {cellWidth:258}
            }  
        })
        
        //4 Donut Charts
        let chartFirstRowY = 160
        await html2Canvas(document.querySelector('#donut_gender'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
          imageTimeout: 0
        }).then(function(canvas){
          PDF.setPage(3)
          let startLocationChart = chartFirstRowY
          let contentWidthChart = (a4Width - leftMargin - rightMargin)/2 * 0.9
          let contentHeightChart = 370 * 0.8

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChart,  contentWidthChart, contentHeightChart)
        })

        this.percentage = 60

        await html2Canvas(document.querySelector('#donut_age'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
          imageTimeout: 0
        }).then(function(canvas){
          PDF.setPage(3)
          let startLocationChart = chartFirstRowY
          let contentWidthChart = (a4Width - leftMargin - rightMargin)/2 * 0.9
          let contentHeightChart = 400 * 0.8

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChart,  contentWidthChart, contentHeightChart)
        })

        this.percentage = 70

        await html2Canvas(document.querySelector('#donut_spend_power'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
          imageTimeout: 1000000
        }).then(function(canvas){
          PDF.setPage(3)
          let startLocationChart = chartFirstRowY + 320
          let contentWidthChart = (a4Width - leftMargin - rightMargin)/2 * 0.9
          let contentHeightChart = 370 * 0.8
          if (param.chosen_city == "Shenzhen" || param.chosen_city ==  "Chongqing" || param.chosen_city ==  "Chengdu")
            contentHeightChart = 400 * 0.8

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', leftMargin, startLocationChart,  contentWidthChart, contentHeightChart)
        })
        
        this.percentage = 80

        await html2Canvas(document.querySelector('#donut_interest'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          allowTaint: true,
          scale: 2,
          imageTimeout: 1000000
        }).then(function(canvas){
          PDF.setPage(3)
          let startLocationChart = chartFirstRowY + 320
          let contentWidthChart = (a4Width - leftMargin - rightMargin)/2 * 0.9
          let contentHeightChart = 440 * 0.8

          let infoPageData = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(infoPageData, 'JPEG', a4Width/2, startLocationChart,  contentWidthChart, contentHeightChart)
        })
        
        this.percentage = 90

        //Page 3
        //Bus Line Detail Page
        PDF.addPage()
        PDF.addImage(BusLogo,'png',leftMargin,30,101/2,49/2)
        PDF.addImage(BamLogo,'png',a4Width-rightMargin-67.375,30,269.5/4,115/4)
        PDF.setFont('Helvetica')
        PDF.setFontSize(14);
        PDF.text('Bus Media Solution - Audience Impressions Based',a4Width/2,99.225+10,'center')
        PDF.setFont('STXIHEI');
        PDF.setFontSize(20);
        PDF.text('巴士媒体受众曝光测量系统',a4Width/2,99.225-20,'center')
        
        PDF.autoTable({
          body: titleTable,
            styles: { font: "STXIHEI"} ,
            //theme:'grid',
            tableWidth: 'auto',
            //cellWidth:250,
            //fontSize:14,
            startY: 123.575+6,
            lineWidth: 10,
            columnStyles: {
              1: {cellWidth:258}
            }  
        })
        //Bus line table
        let tableDataCommercialExport = new Array()
        let tableDataCommercialHeader = []

        if (param.ifShowViewed) {
          if (param.pricingMode == "media") {
            tableDataCommercialHeader = [['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','制作\n刊例费\n总价￥\nTotal\nProduction Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)']]
            param.tableDataCommercial.forEach((item, index) => {
              tableDataCommercialExport[index] = new Array()
              tableDataCommercialExport[index][0] = item['bus_name']
              tableDataCommercialExport[index][1] = item['rank']
              tableDataCommercialExport[index][2] = item['media_type_label']
              tableDataCommercialExport[index][3] = item['bus_quantity']
              tableDataCommercialExport[index][4] = item['duration']
              tableDataCommercialExport[index][5] = item['price']
              tableDataCommercialExport[index][6] = item['production_price']
              tableDataCommercialExport[index][7] = item['impression_total']
              tableDataCommercialExport[index][8] = item['adjusted_impression']
            })
          }
          else {
            tableDataCommercialHeader = [['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','制作\n刊例费\n总价￥\nTotal\nProduction Cost￥','广告有效\n展示次数\nViewed\nImpressions','广告有效\n展示次数\n(基于目标受众)\nViewed\nImpressions\n(Target Audience \nBased)','千次展示\n成本\nCPM￥']]//,'千次展示\n成本\n(基于目标受众)\nCPM￥\n(Target Audience \nBased)'
            param.tableDataCommercial.forEach((item, index) => {
              tableDataCommercialExport[index] = new Array()
              tableDataCommercialExport[index][0] = item['bus_name']
              tableDataCommercialExport[index][1] = item['rank']
              tableDataCommercialExport[index][2] = item['media_type_label']
              tableDataCommercialExport[index][3] = item['bus_quantity']
              tableDataCommercialExport[index][4] = item['duration']
              tableDataCommercialExport[index][5] = item['price']
              tableDataCommercialExport[index][6] = item['production_price']
              tableDataCommercialExport[index][7] = item['impression_total']
              tableDataCommercialExport[index][8] = item['adjusted_impression']
              tableDataCommercialExport[index][9] = item['discount_proposal_CPM']
              //tableDataCommercialExport[index][10] = item['discount_adjusted_proposal_CPM']
            })
          }
        }
        else {
          if (param.pricingMode == "media") {
            tableDataCommercialHeader = [['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','制作\n刊例费\n总价￥\nTotal\nProduction Cost￥','广告有效\n展示次数\nViewed\nImpressions']]
            param.tableDataCommercial.forEach((item, index) => {
              tableDataCommercialExport[index] = new Array()
              tableDataCommercialExport[index][0] = item['bus_name']
              tableDataCommercialExport[index][1] = item['rank']
              tableDataCommercialExport[index][2] = item['media_type_label']
              tableDataCommercialExport[index][3] = item['bus_quantity']
              tableDataCommercialExport[index][4] = item['duration']
              tableDataCommercialExport[index][5] = item['price']
              tableDataCommercialExport[index][6] = item['production_price']
              tableDataCommercialExport[index][7] = item['impression_total']
            })
          }
          else {
            tableDataCommercialHeader = [['巴士线路\nLine','线路级别\nGrade\n(Legacy)','媒体形式\nMedia \nFormat','巴士台数\nBus\nQuantity','发布时长\n（月）\nDuration\n(Month)','媒体\n刊例费\n总价￥\nTotal\nMedia Cost￥','制作\n刊例费\n总价￥\nTotal\nProduction Cost￥','广告有效\n展示次数\nViewed\nImpressions','千次展示\n成本\nCPM￥']]
            param.tableDataCommercial.forEach((item, index) => {
              tableDataCommercialExport[index] = new Array()
              tableDataCommercialExport[index][0] = item['bus_name']
              tableDataCommercialExport[index][1] = item['rank']
              tableDataCommercialExport[index][2] = item['media_type_label']
              tableDataCommercialExport[index][3] = item['bus_quantity']
              tableDataCommercialExport[index][4] = item['duration']
              tableDataCommercialExport[index][5] = item['price']
              tableDataCommercialExport[index][6] = item['production_price']
              tableDataCommercialExport[index][7] = item['impression_total']
              tableDataCommercialExport[index][8] = item['discount_proposal_CPM']
            })
          }
        }
        
        PDF.autoTable({
          head: tableDataCommercialHeader,
          body: tableDataCommercialExport,
            headStyles:{fontStyle:'noraml',fontSize:8},
            columnStyles: {
              0: {halign:'left'},
              1: {halign:'center'},
            },
            styles: { font: "STXIHEI",halign:'right',fontSize:8} ,
            //theme:'grid',
            margin: {left:20,right:20}, 
            tableWidth: '850',
            startY: 160+ifShowViewedDescendPixel,
        })

        
        
        //Add confidentiality agreement
        let confidentialityAgreement = new Image()
        //confidentialityAgreement.src = require('../assets/confidentiality_agreement.png')
        let confidentialityAgreementUrl = _global.serverSrc.slice(0,-4) + picSrc + 'confidentiality_agreement.png';
        confidentialityAgreement.src = confidentialityAgreementUrl
        PDF.addImage(confidentialityAgreement,'png',leftMargin,a4Height-60,a4Width-leftMargin-rightMargin,60) 
        
        //Bus Mape Page 
        html2Canvas(document.querySelector('#map'),{
          scrollX: 0,
          //避免页面上方空白
          scrollY: -window.scrollY,
          taintTest : false,
          allowTaint: false,
          useCORS: true,//允许跨域
          scale: 3,
        }).then(function(canvas){
          PDF.addPage()
          PDF.setFont('STXIHEI');
          PDF.setFontSize(15);
          PDF.text('地图参考页 Map Reference: ',550,30,'',270)

          PDF.setFontSize(6);
          PDF.text('途径地点包括单个POI和商圈\nPOI是地图上单独的点位\n商圈是多个POI的集合',500,30,'',270)
          PDF.text('Nearby Location includes POI and Business Area\nPOI is the single point\nBusiness Area is the assemble of serval POIs',465,30,'',270)

          let contentWidthMap = 600
          let contentHeightMap = 500
          let mapPage = canvas.toDataURL('image/jpeg', 1)
          PDF.addImage(mapPage, 'JPEG', 40,-300,  contentWidthMap, contentHeightMap,'','',270)// rotation 270 degrees
          
          
          //Add page number 
          PDF.setFontSize(10);
          let totalPage = PDF.internal.getNumberOfPages()
          for (let currentPage=1;currentPage<=totalPage-1;currentPage++){
            PDF.setPage(currentPage+1) // avoid cover page
            PDF.text(currentPage+'/'+Number(totalPage-1),a4Width-rightMargin,a4Height-60)
          }
          
          PDF.save(title+ reportDate_output_YYMMDD+'.pdf')
        })
        
        this.percentage = 100

        setTimeout(() => {
          this.dialogProgressVisible = false;
          this.percentage = 0
        }, 2000);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>